import React from 'react';
import '../../styles/get-started-banner.scss';
import '../../styles/pages/incoming-invoices.scss';
import LGSubtitleText from '../ui/typography/LGSubtitleText';
import XSText from '../ui/typography/XSText';
import PrimaryButton from '../ui/buttons/PrimaryButton';
import InvoiceBannerImg from '../../images/graphics/pay/pay-listing-img.png';
import { PATH_PAGE } from '../../routes/paths';
export default function ({ handleUploadInvoice }) {
  return (
    <div className="send-invoice-container rounded-2xl box-shadow md:pl-8 pl-4 flex md:flex-row flex-col md:justify-between overflow-hidden">
      <div className="py-8 md:w-6/12 w-full">
        <div>
          <LGSubtitleText
            className="whitespace-pre-line"
            textWeight="text-bold"
            textColor="text-gray-500"
            title={'Manage and pay your\n suppliers invoices'}
          />
          <XSText
            fontWeight="text-medium"
            className="whitespace-pre-line mt-4"
            textColor="text-gray-500"
            title={
              'Simplify your invoice management process by uploading\n and paying invoices in one place.\n\n Stay organized and keep track of your financial\n transactions effortlessly.'
            }
          />
        </div>
        <div className="pay-invoice-button">
          <PrimaryButton
            id="pay-invoice-banner-upload-btn"
            className="mr-2"
            isBorderRequired="true"
            color="text-white"
            fontSize="text-base"
            fontWeight="text-medium"
            bgColor="bg-green-500"
            caption="Upload your first invoice"
            onClick={handleUploadInvoice}
          />
        </div>
      </div>

      <div className="md:mr-4 md:mt-6 flex md:justify-end justify-center relative md:w-6/12 w-full">
        <div className="green-background-shadow-effect md:block hidden"></div>
        <div className="overflow-hidden image-z-index flex justify-end">
          <img className="pay-invoice-image getPaid-invoice overflow-hidden" src={InvoiceBannerImg} alt="Invoice"></img>
        </div>
      </div>
    </div>
  );
}
